import { ApplicationRole } from "../permission/applicationRole";
import { Organization } from "./organization";
import { Branch } from "./branch";

export interface RoleHierarchy {
  organization: Organization;
  branch: Branch;
  role: ApplicationRole;
}

export const DEFAULT_ROLE_HIERARCHY: RoleHierarchy = {
  branch: { id: "", name: "" },
  organization: { id: "", name: "" },
  role: "Company Admin",
};
